import React, { useMemo } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"
import { Users, FileText, CheckCircle, MapPin, GraduationCap, Star, Award } from "lucide-react"
import { useTranslation } from "react-i18next"; // 1. Import i18next

const RegistrationBenefit: React.FC = () => {
    const { t } = useTranslation('registration'); // 2. Gunakan namespace

    // 3. Gunakan useMemo agar list benefit update saat ganti bahasa
    const benefits = useMemo(() => [
        { icon: Award, text: t('registration_benefits.items.certificate') },
        { icon: Users, text: t('registration_benefits.items.networking') },
        { icon: FileText, text: t('registration_benefits.items.materials') },
        { icon: GraduationCap, text: t('registration_benefits.items.workshop') },
        { icon: CheckCircle, text: t('registration_benefits.items.food') },
        { icon: MapPin, text: t('registration_benefits.items.exhibition') },
    ], [t]);

    return (
        <div className="lg:col-span-1 order-2 lg:order-1 text-left">
            <Card className="lg:sticky lg:top-25 bg-white/90 shadow-xl border-0 dark:bg-gray-800/50 dark:border-gray-700">
                <CardHeader className="pb-4">
                    <CardTitle className="flex items-center gap-2 text-lg md:text-xl text-primary dark:text-blue-400">
                        <Star className="w-5 h-5 md:w-6 md:h-6 text-accent" />
                        {t('registration_benefits.title')}
                    </CardTitle>
                    <CardDescription className="dark:text-gray-300">
                        {t('registration_benefits.subtitle')}
                    </CardDescription>
                </CardHeader>
                <CardContent className="space-y-3 md:space-y-4">
                    {benefits.map((benefit, index) => (
                        <div
                            key={index}
                            className="flex items-start gap-3 p-3 rounded-lg bg-muted/50 hover:bg-muted transition-colors dark:bg-gray-700/50 dark:hover:bg-gray-700"
                        >
                            <benefit.icon className="w-4 h-4 md:w-5 md:h-5 text-accent mt-0.5 flex-shrink-0" />
                            <span className="text-xs md:text-sm font-medium dark:text-gray-200">
                                {benefit.text}
                            </span>
                        </div>
                    ))}
                </CardContent>
            </Card>
        </div>
    );
};

export default RegistrationBenefit;